// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1ynIA","rootCenter":"LoadMoreObserver_rootCenter__1DRzR","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1oHZN"};